"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'polygonRules',
  props: {
    qmOrderInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      direction: 'rtl',
      dialogVisible: false,
      rulesData: {}
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    getDetail: function getDetail(data) {
      this.rulesData = data.polygonRules;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    }
  }
};